module.exports = __webpack_public_path__ + "res/Roboto-Thin-webfont.eot?e9994cc48306582d47373cc67cd397fc";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Thin-webfont.eot
// module id = 56
// module chunks = 0